import type { SVGAttributes } from "react";
import { ICONS, type IconName } from "../icons";
import { cn } from "../lib/cn";

export interface IconProps extends Omit<SVGAttributes<SVGSVGElement>, "name"> {
  name: IconName;
  /** Accessible label. When omitted the icon is decorative (aria-hidden). */
  label?: string;
}

/** Renders a mockup `data-icon` name as its lucide-react component (default size-4). */
export function Icon({ name, label, className, ...rest }: IconProps) {
  const Component = ICONS[name];
  return (
    <Component
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? "img" : undefined}
      focusable="false"
      className={cn("size-4 shrink-0", className)}
      {...rest}
    />
  );
}
